<template>
  <restore-widget
    :title="$t('title')"
    :items="archivedBoards"
    :restore="doRestore"
    :delete="doDelete"
    :dismiss="dismiss"
    :data-loading="loading"
  />
</template>

<script>
import { isEmpty } from 'lodash/lang'
import { mapState, mapActions } from 'vuex'
import { EQ_OPERATOR } from '@argon/app/axios'
import { NAMESPACE } from '../store'
import { RestoreWidget } from '../../components'

export default {
  name: 'BoardRestoreWidget',
  components: { RestoreWidget },
  props: {
    orgRef: String,
    entityType: String,
    dismiss: { type: Function, required: true }
  },
  data: () => ({ loading: true }),
  computed: {
    ...mapState(NAMESPACE, ['archivedBoards']),
    fString() {
      let f = []
      if (this.entityType) {
        f.push(`entity_type:${EQ_OPERATOR}:${this.entityType}`)
      }
      return !isEmpty(f) ? f.join(',') : null
    }
  },

  methods: {
    ...mapActions(NAMESPACE, [
      'listBoards',
      'listArchivedBoards',
      'clearArchivedBoards',
      'restoreBoards',
      'deleteBoards'
    ]),
    doRestore(selected) {
      let paths = selected.map((item) => item.uris.self)
      return this.restoreBoards(paths).then(() => {
        this.listBoards({ filters: this.fString })
      })
    },
    doDelete(selected) {
      let paths = selected.map((item) => item.uris.self)
      return this.deleteBoards(paths).then(() => {
        this.listBoards({ filters: this.fString })
      })
    }
  },
  mounted() {
    this.listArchivedBoards({ filters: this.fString })
      .catch(() => {})
      .finally(() => {
        this.loading = false
      })
  },
  destroyed() {
    this.clearArchivedBoards()
  }
}
</script>

<i18n>
{
  "en": {
    "title": "Archived Boards"
  },
  "fr": {
    "title": "Tableaux archivés"
  }
}
</i18n>
